<template>
    <div class="__surequote-container">
      <h2 class="__sf-tc">{{products.length}} recommended <span class="__sf-light">packages (with installation included)</span></h2>
      <div class="surequote-products">

          <div class="surequote-products__item surequote-products__item--details surequote_finance">

              <div class="surequote-products__section">
                <h3 class="subtitle">About your enquiry</h3>
                <p>Thank you for using the boiler price estimate tool.</p>
                <p>The estimate given is based on the information provided and may be subject to change, upon inspection of your existing heating system or any subsequent changes to your requirements.</p>
                <p>Please note all prices include VAT at the current rate.</p>
                <p v-if="UsesFinance">Subject to availability, pay an initial deposit and spread the payments up to {{maxFinancePeriodInYears}} years</p>
              </div>
              
          </div>

          <div class="surequote-products__item surequote-products__item--products" v-for="(pr, index) in products" :key="index">
              <product-package :pack="pr" :isFinance="showFinanceOptions" :showPackageTypes="showPackageTypes"></product-package>
          </div>
      </div>

      <p v-if="UsesFinance" class="small __sf-tc">{{FinanceSettings.FCADetail}}</p>
      <router-view name="navigation"></router-view>
    </div>
</template>

<script>
// @ is an alias to /src
import store from "@/store/store";
import { mapGetters } from "vuex";
import FinanceSlider from '@/components/FinanceSlider.vue';
import ProductPackage from '@/components/ProductPackage.vue';
import { UPDATE_FINANCE_PERIOD, SUBMIT_QUESTIONS } from '@/store/actions.type.js';

export default {
  name: 'Products',
  data() {
    return {
      showFinanceOptions: false
    }
  },
  computed: {
    ...mapGetters(["products", "FinanceSettings", "UsesFinance"]),
    showPackageTypes() {
        return this.products.length === 3;
    },
    isInterestFree(){
      return this.$store.state.settings.calculatorSettings.selectedFinancePeriod <= this.FinanceSettings.FinanceInterestFreePeriod;
    },
    financePeriod: {
        get() {
            return this.$store.state.settings.calculatorSettings.selectedFinancePeriod;
        },
        set(value) {
            this.$store.dispatch(UPDATE_FINANCE_PERIOD, value)
        }
    },
    maxFinancePeriodInYears(){
      return this.FinanceSettings.FinancePeriod / 12
    }
  },
  components: {
    FinanceSlider, ProductPackage
  }
}
</script>
